import {
    Button,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    IconButton,
    Stack,
    Typography,
} from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { palette } from '../../styles/theme';
import CloseIcon from '@mui/icons-material/Close';

const GeneralModal = ({
    isOpen,
    onClose,
    UIProps,
    title,
    icon,
    children,
    mainButton,
    secondaryButton,
    height,
    width,
    bottomTop,
    marginTopProps,
    showCloseButton,
    padding,
    headerDirection,
    contentStyle,
    borderRadius,
    actionsStyle,
}) => {
    const { t } = useTranslation();
    const { isDisabled = {}, onMainButtonClick = () => {}, sx: mainButtonSx = {} } = mainButton ?? {};
    const { onSecondaryButtonClick = () => {}, title: secondaryButtonTitle, sx: secondaryButtonSx = {} } = secondaryButton ?? {};

    const hasOnlyOneButton = mainButton && !secondaryButton;

    return (
        <Dialog
            open={isOpen}
            onClose={() => onClose()}
            PaperProps={{
                style: {
                    width: width || '24.62rem',
                    minWidth: '24.62rem',
                    height: height || '30.77rem',
                    padding: padding || '2.46rem',
                    borderRadius: borderRadius || '1.85rem',
                },
                className: 'modal_clientsFilters'
            }}
        >
            {showCloseButton && (
                <IconButton
                    onClick={onClose}
                    sx={{
                        position: 'absolute',
                        top: '1.23rem',
                        right: '1.23rem',
                        zIndex: 10,
                    }}
                >
                    <CloseIcon sx={{ color: palette.secondary.main, fontSize: '2.15rem' }} />
                </IconButton>
            )}
            {title && icon &&
            <DialogTitle style={{ padding: 0 }}>
                <Stack
                    direction={headerDirection || 'column'}
                    alignItems={'center'}
                    gap={headerDirection === 'row' ? '0.62rem' : '0rem'}
                    justifyContent='flex-start'
                >
                    {icon}
                    <Typography
                        sx={{
                            marginLeft: headerDirection === 'row' ? '0rem' : '0.46rem',
                            marginTop: headerDirection === 'row' ? '0rem' : '0.23rem'
                        }}
                        variant='h2'
                        color={palette.disabled[950]}
                    >
                        {t(title)}
                    </Typography>
                </Stack>
            </DialogTitle>
            }
            <DialogContent style={{
                marginTop: marginTopProps || '2rem',
                marginBottom: '3.08rem',
                padding: 0,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                ...contentStyle,
            }}>
                {children}
            </DialogContent>
            {
                mainButton &&
            <DialogActions style={{
                padding: '0 1rem',
                gap: '1rem',
                display: 'flex',
                flexDirection: bottomTop ? 'column' : 'row',
                justifyContent: hasOnlyOneButton ? 'center' : 'flex-end',
                marginTop: marginTopProps || '0rem',
                ...actionsStyle,
            }}>
                {secondaryButton &&
                    <Button
                        className='delete_button--cancel'
                        sx={{
                            boxShadow: 'none',
                            '&:hover': {
                                backgroundColor: 'transparent',
                                boxShadow: 'none',
                            },
                            ...secondaryButtonSx,
                        }}

                        variant='text'
                        onClick={onSecondaryButtonClick}>
                        {t(secondaryButtonTitle)}
                    </Button>
                }

                <Button
                    disabled={isDisabled}
                    variant='contained'
                    className='delete_button--submit'
                    style={{ width: hasOnlyOneButton ? '90%' : 'auto', height: '3.38rem' }}
                    sx={{
                        boxShadow: 'none',
                        '&:hover': {
                            boxShadow: 'none',
                        },
                        ...mainButtonSx,
                    }}
                    onClick={onMainButtonClick}
                >
                    {UIProps?.isLoading
                        ? <CircularProgress
                            size='1.85rem'
                            sx={{ color: 'white' }}
                        />
                        : t(mainButton.title ?? 'buttons.confirm')}
                </Button>
            </DialogActions>
            }

        </Dialog>
    );
};

export default GeneralModal;
